import AddReviewForm from "../../forms/AddReviewForm";

export default function AddReview() {
  return (
    <div class="hero">
      <div class="hero-content flex-col">
        <div class="text-center lg:text-left">
          <h1 class="text-5xl font-bold">Add Your Review</h1>
        </div>

        <AddReviewForm />
      </div>
    </div>
  );
}
